module.exports = {"TAG_DEFAULT_INPUT_PLACEHOLDER":"You have reached the element limit","TAG_ADD_BUTTON":"Add","TAG_INVALID_VALUE":"Invalid value"}